import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { useState, useEffect } from 'react'

export function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(() => {
    const saved = localStorage.getItem('sidebar-collapsed')
    try {
      const parsed = saved ? JSON.parse(saved) as unknown : false
      return typeof parsed === 'boolean' ? parsed : false
    } catch {
      return false
    }
  })
  const [isMobile, setIsMobile] = useState(false)

  // Check if we're on mobile and auto-collapse sidebar on mobile
  useEffect(() => {
    const checkMobile = () => {
      const isMobileScreen = window.innerWidth < 768
      setIsMobile(isMobileScreen)
      
      // Auto-collapse sidebar on mobile screens for better space utilization
      if (isMobileScreen) {
        setSidebarCollapsed(true)
      }
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => { window.removeEventListener('resize', checkMobile) }
  }, [])

  // Save sidebar collapsed state to localStorage
  useEffect(() => {
    localStorage.setItem('sidebar-collapsed', JSON.stringify(sidebarCollapsed))
  }, [sidebarCollapsed])

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  return (
    <div className="flex h-full bg-gray-50 dark:bg-gray-900">
      <Sidebar 
        collapsed={sidebarCollapsed} 
        onToggle={toggleSidebar}
        isMobile={isMobile}
      />
      
      <div className="flex-1 flex flex-col min-h-0 min-w-0">
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
